var $177331a39d162ddc$exports = {};
$177331a39d162ddc$exports = {
    "loading": `Ladataan\u{2026}`,
    "loadingMore": `Ladataan lis\xe4\xe4\u{2026}`
};


export {$177331a39d162ddc$exports as default};
//# sourceMappingURL=fi-FI.module.js.map
